import React from 'react';

const ManageItems = () => {
    return (
        <div>
            <h3 className='text-center m-4'>Manage Items</h3>
        </div>
    );
};

export default ManageItems;